import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigurationStatusButton } from "../../../Configuration";
/**
 * Wrapper around ConfigurationStatusButton for SubstructureInstanceStatusButton so we have the same property names
 * @param props
 * @returns
 */
export function SubstructureInstanceStatusButton(props) {
    const { substructure } = props;
    return _jsx(ConfigurationStatusButton, { cfgObject: substructure });
}
//# sourceMappingURL=SubstructureInstanceStatusButton.js.map